/**************************************************
 * Nombre:       Tarejeta_Paso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import cuadro from '../../Recursos/Temporales/img_cuadro.svg'

const Tarejeta_Paso = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 38.34%, rgba(168, 165, 172, 0.68) 67.44%, #F7F3FE 96.28%), url(${item.img})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    p: 2,
                    borderRadius: 8
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 24}}>
                    <Typography sx={{color: '#1B0B3B', fontSize: 24, fontWeight: 600, textAlign: 'center'}}>
                        {item.periodo}
                    </Typography>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Typography sx={{
                    color: '#7A1CFF',
                    fontSize: 14,
                    fontWeight: 300,
                    textAlign: 'center',
                    border: 1,
                    borderColor: '#7A1CFF',
                    px: 2,
                    borderRadius: 4
                }}> {item.periodo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{color: '#1B0B3B', fontSize: 18, fontWeight: 600, textAlign: 'left'}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{color: '#5B5470', fontSize: 16, fontWeight: 300, textAlign: 'left', lineHeight: 1.3}}>
                    {item.descripcion}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarejeta_Paso    